import { useContext } from 'react';

import { HistogramThresholdContext } from '../contexts/HistogramThreshold.context.js';

export const useHistogramThresholds = () =>
  useContext(HistogramThresholdContext);
